import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

interface IFormSubmitButton {
  loading?: boolean;
  children: string;
  className?: string;
  disabled?: boolean;
  // onClick?: (...args: any) => any;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const FormSubmitButton: React.FC<IFormSubmitButton> = ({
  loading,
  children,
  className,
  disabled,
  onClick,
}) => {
  return (
    <FormSubmitBtn
      disabled={disabled}
      className={className ? className : ''}
      type='submit'
      onClick={onClick}
    >
      {loading && <LoadingOutlined />}
      {children}
    </FormSubmitBtn>
  );
};

export const FormSubmitBtn = styled.button`
  border: 1px solid ${({ theme }) => theme.palette.redFontColor};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  padding: 13px 24px;
  line-height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  color: white;
  background-color: ${({ theme }) => theme.palette.redFontColor};
  height: fit-content;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.redHoverFontColor};
  }

  &:disabled,
  &.disabled:hover {
    color: ${({ theme }) => theme.palette.borderColor};
    background-color: ${({ theme }) => theme.palette.offWhite};
    border-color: ${({ theme }) => theme.palette.offWhite};
    cursor: not-allowed;
  }

  &.fit-content {
    width: fit-content;
  }

  &.flex-end {
    justify-self: flex-end;
  }
`;
